import React, { useEffect, useState } from "react";
import { cases as casesApi } from "../api/endpoints";
import Spinner from "../components/Spinner";
import Empty from "../components/Empty";
import { TipoPill, EstadoPill } from "../components/Pills";
import CaseDetail from "./case-detail";
import { useRefreshOnNotification } from "../components/useRefreshOnNotification";

const fmt = (d) => d ? new Date(d).toLocaleString("es-CO") : "—";

export default function AuditQueue() {
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);

  function load() {
    setData(null);
    casesApi.list({ estado: "en_auditoria" }).then(r => setData(r.data)).catch(() => setData([]));
  }
  useEffect(() => { load(); }, []);
  useRefreshOnNotification(["audit_pending"], load);

  return (
    <div className="col" style={{ gap: 16 }}>
      <h1 style={{ margin: 0 }}>Casos en auditoría</h1>
      <div className="muted" style={{ marginTop: -8 }}>Apruebe o devuelva con observaciones. La regla de mismo auditor se aplica automáticamente.</div>

      <div className="card" style={{ padding: 0 }}>
        {data == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !data.length ? (
          <Empty title="No hay casos en auditoría" message="Cuando un abogado envíe trabajo, aparecerá aquí." />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Caso</th><th>Tipo de actuación</th><th>Accionante</th><th>Abogado</th>
                <th>Auditor anterior</th><th>Enviado</th><th>Estado de la actuación</th>
              </tr>
            </thead>
            <tbody>
              {data.map(c => (
                <tr key={c.id} onClick={() => setOpenId(c.id)} style={{ cursor: "pointer" }}>
                  <td><strong>{c.case_number}</strong></td>
                  <td><TipoPill tipo={c.tipo} /></td>
                  <td>{c.accionante_nombre || "—"}</td>
                  <td>{c.abogado_nombre || "—"}</td>
                  <td>{c.last_auditor_id ? <span className="badge warning">Reapertura</span> : <span className="muted">Primera vez</span>}</td>
                  <td>{fmt(c.updated_at)}</td>
                  <td><EstadoPill c={c} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <CaseDetail caseId={openId} open={!!openId} defaultTab="auditoria" onClose={() => setOpenId(null)} onChanged={load} />
    </div>
  );
}
